import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  action: string;
}


@Component({
  selector: 'app-action-dialogue',
  templateUrl: './action-dialogue.component.html',
  styleUrls: ['./action-dialogue.component.scss']
})
export class ActionDialogueComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ActionDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close({ result: 0 });
  }

  onYesClick(): void {
    this.dialogRef.close({ result: 1 })
  }

}
